module.exports = __webpack_public_path__ + "img/phone.96092ea0.svg";